// extracted by mini-css-extract-plugin
var _1 = "_7p7tw__gameFooter";
var _2 = "_7p7tw__settings";
var _3 = "_7p7tw__settings__key";
var _4 = "_7p7tw__settings__setting";
var _5 = "_7p7tw__state";
export { _1 as "gameFooter", _2 as "settings", _3 as "settings__key", _4 as "settings__setting", _5 as "state" }
